<template>
  <div class="age-range">
    <div class="age-select-wrapper is-disabled">
      <select class="age-select" :value="minValue" disabled aria-label="Min age">
        <option :value="minValue">{{ minValue }}</option>
      </select>
    </div>

    <span class="age-separator">–</span>

    <div class="age-select-wrapper">
      <select class="age-select" :value="maxValue" aria-label="Max age" @change="onMaxChange">
        <option v-for="opt in maxOptions" :key="opt" :value="opt">{{ opt }}</option>
      </select>
    </div>
  </div>
</template>

<script>
// Idades aceitas pela DV360
const AGE_OPTIONS = ['18', '25', '35', '45', '55', '65', '65+']

export default {
  name: 'AgeSlider',
  props: {
    value: {
      type: Array,
      required: true
    }
  },
  computed: {
    minValue () {
      return String(this.value[0] ?? AGE_OPTIONS[0])
    },
    maxValue () {
      return String(this.value[1] ?? AGE_OPTIONS[AGE_OPTIONS.length - 1])
    },
    maxOptions () {
      const minIndex = AGE_OPTIONS.indexOf(this.minValue)
      return AGE_OPTIONS.slice(minIndex + 1)
    }
  },
  methods: {
    onMaxChange (event) {
      this.$emit('input', [this.minValue, event.target.value])
    }
  }
}
</script>

<style scoped>
.age-range {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.age-separator {
  color: #d8ab44;
  font-weight: 700;
}

/* borda amarela */
.age-select-wrapper {
  position: relative;
  padding: 2px;
  border-radius: 10px;
  background: #d8ab44;
  transition: box-shadow 0.2s ease;
}

.age-select-wrapper:not(.is-disabled):hover,
.age-select-wrapper:not(.is-disabled):focus-within {
  box-shadow: 0 0 0 3px rgba(216, 171, 68, 0.25);
}

.age-select-wrapper.is-disabled {
  opacity: 0.6;
}

.age-select {
  appearance: none;
  -webkit-appearance: none;
  display: block;
  min-width: 90px;
  padding: 0.45rem 2rem 0.45rem 0.9rem;
  border: 0;
  border-radius: 8px;
  background-color: #fff;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'><path d='M0 0l5 6 5-6z' fill='%23000'/></svg>");
  background-repeat: no-repeat;
  background-position: right 0.8rem center;
  color: #000;
  font-weight: 600;
  cursor: pointer;
  outline: none;
}

.age-select:disabled {
  cursor: not-allowed;
}

.age-select option {
  background: #fff;
  color: #000;
}
</style>
